import { axios } from '@ben/api/axios';

export const deleteModularBenefit = async (
  id: number | string,
  versionId?: string
): Promise<unknown> => {
  const versionSuffix = versionId ? `versions/${versionId}/` : '';
  const response =
    typeof window === 'undefined'
      ? { data: {} }
      : await axios.delete(`benefits/${id}/${versionSuffix}`);
  return response?.data;
};
